<template>
  <div class="col-12 col-md-6 form-group form-group-sm">
    <label class="label" for="tipoContrato">Tipo Contrato</label>
    <multiselect-item
      id="tipoContrato"
      v-model="tipoContrato"
      :custom-label="label"
      :options="tipoContratoOptions"
      placeholder="Seleccione un tipo de contrato"
      track-by="id_contrato_tipos"
      :loading="isLoading"
    ></multiselect-item>
  </div>
</template>

<script>
import { get } from "lodash-es";
import AdaptarVueModel from "../../shared/AdaptarVueModel";
import axios from "axios";

export default {
  name: "SelectTipoContrato",
  mixins: [AdaptarVueModel],
  props: ["value"],
  mounted() {
    this.getTiposContrato();
  },
  data: () => ({
    tipoContratoOptions: [],
    isLoading: true,
  }),
  methods: {
    label(contratoTipo) {
      return `${contratoTipo.nombre_contrato} - Precio: $${contratoTipo.precio} (Instalacion: $${contratoTipo.precio_instalac})`;
    },
    async getTiposContrato() {
      this.isLoading = true;
      const { data } = await axios.post("/execute", {
        method: "CLI.GetContratoTipos",
        parameters: [],
      });
      if (data.ok) {
        this.tipoContratoOptions = get(data, "result[0]", []);
        this.adaptarVueModel(this.tipoContratoOptions, "id_contrato_tipos");
      } else {
        this.$msgBoxOk(data.message);
      }
      this.isLoading = false;
    },
  },
  computed: {
    tipoContrato: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
};
</script>

<style scoped></style>
